import type { AxiosInstance } from "axios";

import type { OwnerDetails } from "~/v2/api/rest/account";
import type {
  AssetAddressData,
  AssetAddressDisplay,
  WhitelistAddressMode,
} from "../types";
import type { TravelRuleFormValues } from "./schema";
import { useTravelRuleForm } from "./TravelRuleForm.controller";
import { TravelRuleFormPresentation } from "./TravelRuleForm.pres";

export interface TravelRuleFormProps {
  cryptoWalletAxiosInstance: AxiosInstance;
  accountId: string;
  assetAddressData: AssetAddressData;
  assetAddressDisplay: AssetAddressDisplay;
  mode: WhitelistAddressMode;
  accountDetails?: OwnerDetails;
  onSuccess: () => void;
  initialValues?: Partial<TravelRuleFormValues>;
  onBack?: () => void;
}

export const TravelRuleForm = ({
  assetAddressData,
  assetAddressDisplay,
  onBack,
  ...controllerProps
}: TravelRuleFormProps) => {
  const controller = useTravelRuleForm({
    assetAddressData,
    ...controllerProps,
  });

  return (
    <TravelRuleFormPresentation
      {...controller}
      assetAddressData={assetAddressData}
      assetAddressDisplay={assetAddressDisplay}
      onBack={onBack}
    />
  );
};
